import React, { useState, useEffect, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faCircleXmark, faPaperclip, faFileArrowDown, faPaperPlane, faTimes, faFilter, faFileLines, faEllipsisVertical, faPencilAlt, faCircle, faUser, faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { Form, Button, Accordion, Row, Col, Modal, Table, Tabs, Tab, Dropdown } from 'react-bootstrap';
import { withRFSToken } from '../../../../../Services/axios';
import { toast } from 'react-toastify';
import Select from 'react-select';
import { Link } from 'react-router-dom';
import pen from "../../../../../assets/images/pen.png";
import xls_file from "../../../../../assets/images/xls-file.png";
import Trash from "../../../../../assets/images/trash.png";
import dwnld from "../../../../../assets/images/dwnld.png";
import cargohub_logo from "../../../../../assets/images/cargohub-logo.png";
import Download_pdf from "../../../../../assets/images/pdf.png";
import mail from "../../../../../assets/images/mail.png";
import dlt from '../../../../../assets/images/dlt.png';
import greencheck from "../../../../../assets/images/green_check.png";
import manualgreencheck from "../../../../../assets/images/manual_check.png";
import { map } from 'jquery';
import ConfModal from '../../../../../Components/common/ConfModal'; 
import { CallApi, jqxCookieCall } from '../../../../../Components/common/CommonFunctions.js'; 

const Invoice = ({ allData, onDetails, offDetails, onSave, onEdit, loadDetails }) => {
    // console.log('allData',allData);

    const currencyOptions = [
        { value: "EUR", label: "EUR (€) - Euro", symbol: '€' },
        { value: "USD", label: "USD ($) - US Dollar", symbol: '$' },
        { value: "PHP", label: "PHP (₱) - Philippine Peso", symbol: '₱' },
        { value: "JPY", label: "JPY (¥) - Japanese Yen", symbol: '¥' },
        { value: "GBP", label: "GBP (£) - British Pound", symbol: '£' },
        { value: "AUD", label: "AUD (A$) - Australian Dollar", symbol: 'A$' },
        { value: "CHF", label: "CHF (Fr.) - Swiss Franc", symbol: 'Fr.' },
        { value: "CAD", label: "CAD (C$) - Canadian Dollar", symbol: 'C$' },
        { value: "MXN", label: "MXN ($) - Mexican Peso", symbol: '$' },
        { value: "CNY", label: "CNY (¥) - Chinese Yuan", symbol: '¥' },
        { value: "NZD", label: "NZD (NZ$) - New Zealand Dollar", symbol: 'NZ$' },
        { value: "SEK", label: "SEK (kr) - Swedish Krona", symbol: 'kr' },
        { value: "RUB", label: "RUB (₽) - Russian Ruble", symbol: '₽' },
        { value: "HKD", label: "HKD (HK$) - Hong Kong Dollar", symbol: 'HK$' },
        { value: "NOK", label: "NOK (kr) - Norwegian Krone", symbol: 'kr ' },
        { value: "SGD", label: "SGD (S$) - Singapore Dollar", symbol: 'S$' },
        { value: "TRY", label: "TRY (₺) - Turkish Lira", symbol: '₺' },
        { value: "KRW", label: "KRW (₩) - South Korean Won", symbol: '₩' },
        { value: "ZAR", label: "ZAR (R) - South African Rand", symbol: 'R' },
        { value: "BRL", label: "BRL (R$) - Brazilian Real", symbol: 'R$' },
        { value: "INR", label: "INR (₹) - Indian Rupee", symbol: '₹' },
        { value: "SAR", label: "SAR (﷼) - Saudi Riyal", symbol: '﷼' },
        { value: "DKK", label: "DKK (kr) - Danish Krone", symbol: 'kr' },
        { value: "RON", label: "RON (lei) - Romanian Leu", symbol: 'lei' },
        { value: "XAF", label: "XAF (Fr) - Central African CFA Franc", symbol: 'Fr' },
        { value: "XOF", label: "XOF (Fr) - West African CFA Franc", symbol: 'Fr' },
        { value: "DOP", label: "DOP (RD$) - Dominican Peso", symbol: 'RD$)' },
        { value: "HTG", label: "HTG (G) - Haitian Gourde", symbol: 'G' },
        { value: "BBD", label: "BBD (Bds$) - Barbadian Dollar", symbol: 'Bds$' },
        { value: "TTD", label: "TTD (TT$) - Trinidad and Tobago Dollar", symbol: 'TT$)' },
        { value: "XCD", label: "XCD (EC$) - East Caribbean Dollar", symbol: 'EC$' },
        { value: "ANG", label: "ANG (ƒ) - Netherlands Antillean Guilder", symbol: 'ƒ' },
        { value: "COP", label: "COP (COL$) - Colombian Peso", symbol: 'COL$' },
        { value: "XDR", label: "XDR (SDR) - IMF Special Drawing Rights", symbol: 'SDR' },
        { value: "XBT", label: "XBT (₿) - Bitcoin", symbol: '₿' },
        { value: "WGH", label: "WGH - West German Hard Currency", symbol: 'WGH' },
    ];

    const vatRates = [
        // { value: '', label: 'Select VAT Rate', percent: 0 },
        { value: '0', label: '0% - Exempt', percent: 0 },
        // { value: '5', label: '5% - Reduced Rate', percent: 5 },
        { value: '9', label: '9% - Standard Rate', percent: 9 },
        // { value: '18', label: '18% - Standard Rate', percent: 18 },
        // { value: '20', label: '20% - General Rate', percent: 20 },
        { value: '21', label: '21% - General Rate', percent: 21 },
    ];
    const defaultRow = {
        no: 1,
        category: '',
        costs: '',
        ttl: '',
        vat: '0',
        vatAmount: 0,
    };
    const getCurrencySymbol = () => {
        const found = currencyOptions.find(opt => opt.value === selectedCurrency);
        return found ? found.symbol : '';
    };

    const isMounted = useRef(false);
    const invoiceRef = useRef(null);
    const gridRef = useRef(null);
    const gridRefi = useRef(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isLoadingi, setIsLoadingi] = useState(true);
    const [gridData, setGridData] = useState([]);
    const [iGridData, setIGridData] = useState([]);
    const [detailsData, setDetailsData] = useState({});
    const [formData, setFormData] = useState([]);

    const [invoiceDetails, setInvoiceDetails] = useState([]);
    const [categoriesList, setCategoriesList] = useState([]);
    const [allCategories, setAllCategories] = useState(null);
    const [disLoading, setDisLoading] = useState(false);
    const [selectedCurrency, setSelectedCurrency] = useState('EUR');
    const [vatType, setVatType] = useState('exclude');
    const [vatRows, setVatRows] = useState([]);
    const [rows, setRows] = useState([{ ...defaultRow }]);
    const [categoryModal, setCategoryModal] = useState(false);
    const [modalFor, setModalFor] = useState('');
    const [gridSelect, setGridSelect] = useState([]);
    const [selectedRowData, setSelectedRowData] = useState(null);
    const [filterApplied, setFilterApplied] = useState(false);
    const [rowAdd, setRowAdd] = useState(false);
    const [modalConf, setModalConf] = useState(false);
    const [confData, setConfData] = useState({});
    const [isUpdate, setIsUpdate] = useState(false);

    const formattedDate = new Date().toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });

    useEffect(() => {
        if (isMounted.current) return;
        // setDetailsData(allData);
        // setFormData(allData?.invoices);
        getCategory(selectedCurrency)
        setIsLoadingi(false);
        setIGridData([]);
        isMounted.current = true;
    }, []);
    useEffect(() => {
        setDetailsData(allData);
        setFormData(allData?.invoices);
        setSelectedRowData(null);
    }, [allData]);

    const getCategory = async (curr) => {
        setDisLoading(true)
        try {
            const res = await withRFSToken.get(`shipment/get-invoice-categories?currency=${curr ? curr : selectedCurrency}&status=Active`)
                .then(function (res) {
                    const innerData = res.data.Rows;
                    setAllCategories(innerData)
                    // const actCat = innerData?.filter(i => i.activity_status == 1 && i.currency.toLowerCase() == selectedCurrency.toLowerCase()).map(data => ({
                    //     label: data.category,
                    //     value: data.id,
                    //     id: data.id,
                    //     cost: data.cost,
                    //     vat: data.vat,
                    // }))
                    const actCat = innerData?.map(data => ({
                        label: data.category,
                        value: data.id,
                        id: data.id,
                        cost: data.cost,
                        vat: data.vat,
                    }))

                    setCategoriesList(actCat);
                    setDisLoading(false)
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleClose = () => setCategoryModal(false);
    const handleShow = () => {
        setCategoryModal(true);
        setModalFor('ac')
        // getCategory();
        if (allData?.invoices.length && allData?.invoices[0]?.currency) {
            setSelectedCurrency(allData?.invoices[0]?.currency)
        } else {
            setSelectedCurrency('EUR')
        }
        setRows(invoiceDetails.length ? invoiceDetails : [{ ...defaultRow }])
    }

    const handleCloseGrid = () => {
        setModalFor('ac')
        setGridSelect([]);
    }
    const handleAddtoRow = () => {

        if (gridSelect.length > 0) {
            const activeRows = rows.filter(dta => dta.category !== '');
            // console.log('activeRows',activeRows);

            const updatedRows = gridSelect.map((dta, index) => ({ no: activeRows.length + index + 1, category: dta.id, amount: dta.cost, vat: dta.vat, id: dta.id }))
            setRows([
                ...activeRows,
                ...updatedRows
            ]);
            setGridSelect([]);
            setModalFor('ac')
        } else {
            toast.error('Please select row first');
        }
    }

    const handleAddRow = () => {
        setRows([
            ...rows,
            {
                ...defaultRow,
                no: rows.length + 1,
            },
        ]);
    };
    const handleDeleteRow = (idx) => {
        if (rows.length === 1) return;
        const updatedRows = rows.filter((_, i) => i !== idx).map((row, i) => ({ ...row, no: i + 1 }));
        setRows(updatedRows);
    };
    const handleRowChange = (idx, field, value) => {
        let normalizedValue = value;
        if (field === 'amount') {
            normalizedValue = value.toString().replace(',', '.');
        } else if (field === 'qty' || field === 'vat') {
            normalizedValue = rows[idx]?.amount?.toString().replace(',', '.');
        }
        const updatedRows = rows.map((row, i) => {
            if (i === idx) {
                let updatedRow = { ...row, [field]: value };
                // Recalculate VAT Amount if costs or vat changes
                if (field === 'category') {
                    updatedRow = {
                        ...row,
                        [field]: value.value,
                        amount: value.cost,
                        category: value.id,
                        ttl: ((rows[idx].qty * value.cost)).toFixed(2),
                        vat: value.vat,
                        vatAmount: calculateVatAmount(rows[idx].qty * value.cost, value.vat)
                    };
                }
                if (field === 'qty') {
                    updatedRow = {
                        ...row,
                        [field]: value,
                        ttl: (Number(value) * Number(normalizedValue)).toFixed(2),
                        vatAmount: calculateVatAmount(value * Math.floor(Number(normalizedValue)), rows[idx].vat)
                    };
                }
                if (field === 'amount') {
                    updatedRow = {
                        ...row,
                        [field]: value,
                        ttl: (normalizedValue * Number(rows[idx].qty)).toFixed(2),
                        vatAmount: calculateVatAmount(normalizedValue * Math.floor(Number(rows[idx].qty)), rows[idx].vat)
                    };
                }
                if (field === 'vat') {
                    updatedRow = {
                        ...row,
                        [field]: value,
                        vatAmount: calculateVatAmount(rows[idx].qty * Math.floor(Number(normalizedValue)), value)
                    };
                }
                // if (field === 'category' || field === 'qty') {
                //     updatedRow.vatAmount = calculateVatAmount(
                //         row.ttl, row.vat
                //     );
                // }
                return updatedRow;
            }
            return row;
        });
        setRows(updatedRows);

        const vatTotals = {};

        updatedRows.forEach(row => {
            const vat = row.vat;
            const ttl = Number(row.ttl) || 0;

            if (!vatTotals[vat]) {
                vatTotals[vat] = 0;
            }

            vatTotals[vat] += ttl;
        });
        const vatResults = Object.entries(vatTotals).map(([vat, totalTtl]) => {
            const vatPercentage = Number(vat);
            const vatAmount = ((totalTtl * vatPercentage) / 100).toFixed(2);

            return {
                vat: vatPercentage,
                totalTtl,
                vatAmount,
            };
        });
        setVatRows(vatResults)
    };
    const handleCurrencyChange = (e) => {
        setSelectedCurrency(e.target.value);
        const filterCat = allCategories?.filter(i => i.currency.toLowerCase() == e.target.value.toLowerCase()).map(data => ({
            label: data.category,
            value: data.id,
            id: data.id,
            cost: data.cost,
            vat: data.vat,
        }))
        // setCategoriesList(filterCat);
        getCategory(e.target.value)
        setRows((prev) =>
            prev.map((i => ({
                category: '',
                amount: '',
                costs: '',
                no: 1,
                ttl: '',
                vat: '',
                vatAmount: "0.00"
            }))
            ));
    };
    const calculateVatAmount = (costs, vatValue) => {
        const vatObj = vatRates.find(v => v.value == vatValue);
        const percent = vatObj ? vatObj.percent : 0;
        const costNum = parseFloat(costs) || 0;
        return ((costNum * percent) / 100).toFixed(2);
    };

    // Calculate Subtotal, VAT Total, and Grand Total
    const getSubtotal = () => rows.reduce((sum, row) => sum + (parseFloat(row.ttl) || 0), 0);
    const getVatTotal = () => rows.reduce((sum, row) => sum + (parseFloat(row.vatAmount) || 0), 0);
    const getGrandTotal = () => {
        if (vatType === 'exclude') {
            return getSubtotal() + getVatTotal();
        } else {
            return getSubtotal();
        }
    };
    const invoiceSubtotal = () => invoiceDetails?.reduce((sum, row) => sum + (parseFloat(row.ttl) || 0), 0) || 0;
    const invoiceVatTotal = () => invoiceDetails?.reduce((sum, row) => sum + (parseFloat(row.vatAmount) || 0), 0) || 0;
    const invoiceTotal = () => {
        return invoiceSubtotal() + invoiceVatTotal();
    }

    const handleSave = async (act, actData) => {
        console.log('rows: 2', actData);
        const isValid = rows.every(row => row.qty && row.qty !== "");
        if (!act && !isValid) {
            toast.error('Please insert quantity')
            return;
        }

        const trRows = rows?.map(item => {
            let amount = item.amount;
            if (typeof amount === "string") {
                amount = parseFloat(amount.replace(",", "."));
            }
            return {
                ...item,
                amount
            };
        });
        const itemId = actData?.map(({ id, created_at, invoice_category_setting_id, shipment_invoice_id, status, total, updated_at, ...rest }) => {
            let amount = rest.amount;
            if (typeof amount === "string") {
                amount = parseFloat(amount.replace(",", "."));
            }
            return {
                ...rest,
                amount
            };
        });

        // console.log("🚀 ~ handleSave ~ trRows:", trRows)

        if (act) {
            console.log('if');
            setInvoiceDetails(rows)
            setCategoryModal(false)
            // const rowTtl = actData.reduce((sum, row) => sum + parseFloat(row.ttl || 0), 0).toFixed(2)
            const addd = { currency: selectedCurrency, total: selectedRowData.subtotal, items: itemId, updated_at: `${new Date().toISOString()}T1`, status: 'New', new: true }
            // console.log("🚀 ~ handleSave ~ selectedCurrency:", selectedCurrency)
            setFormData(prev => [...(Array.isArray(prev) ? prev : []), addd]);
            setSelectedRowData(addd)
            setInvoiceDetails(actData);
            onSave([...(Array.isArray(formData) ? formData : []), addd])
            // setSelectedRowData(null);
        } else {
            if (rowAdd) {
                console.log('add');

                setInvoiceDetails(rows)
                setCategoryModal(false)
                const rowTtl = rows.reduce((sum, row) => sum + parseFloat(row.ttl || 0), 0).toFixed(2)
                const addd = { currency: selectedCurrency, total: rowTtl, items: trRows, updated_at: `${new Date().toISOString()}T1`, status: 'New', new: true }
                // console.log("🚀 ~ handleSave ~ selectedCurrency:", selectedCurrency)
                let saveData;
                const checkId = formData.find(item => item.id === undefined);
                console.log('checkId', checkId);

                if (formData.length > 0 && checkId) {
                    saveData = formData?.map((invoice, index) =>
                        invoice.id === undefined
                            ? addd
                            : invoice
                    )
                    setFormData(saveData);
                    // setSelectedRowData(null)
                    onSave(saveData)
                } else {
                    setFormData(prev => [...(Array.isArray(prev) ? prev : []), addd]);
                    // setSelectedRowData(null)
                    onSave([...(Array.isArray(formData) ? formData : []), addd])
                }
                // setFormData(prev => [...(Array.isArray(prev) ? prev : []), addd]);
                // onSave([...(Array.isArray(formData) ? formData : []), addd])
                // setSelectedRowData(null);
            } else {
                console.log('else else ');
                setCategoryModal(false)
                setInvoiceDetails(rows)
                const saveData = formData?.map(invoice =>
                    invoice.id === selectedRowData.id
                        ? { ...invoice, edited: true, items: trRows }
                        : invoice
                )

                setFormData(saveData);
                onSave(saveData)
            }
        }
        setIsUpdate(true)
        onDetails()
    };

    const handleToggleCat = (idx) => {
        setRows(prevRows =>
            prevRows.map((row, i) =>
                i === idx ? { ...row, newCat: !row.newCat } : row
            )
        );
    }
    //  download
    const downloadInvoice = async (fileType, iId) => {
        try {
            const localId = JSON.parse(localStorage.getItem('SHEdit'));
            if (!localId) {
                toast.error('Missing invoice id');
                return;
            }

            const payload = { id: Number(iId), type: fileType };
            const acceptType = fileType === 'excel'
                ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                : 'application/pdf';

            const response = await withRFSToken.post('download-invoice', payload, {
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': acceptType,
                },
                responseType: 'blob',
            });

            const contentType = response?.headers?.['content-type'] || acceptType;
            const blob = new Blob([response.data], { type: contentType });
            const url = window.URL.createObjectURL(blob);
            const anchor = document.createElement('a');
            anchor.href = url;

            let filename = `Invoice_${formData?.job_nr || formData?.job_no || 'import'}.${fileType === 'excel' ? 'xlsx' : 'pdf'}`;
            const disposition = response?.headers?.['content-disposition'];
            if (disposition && disposition.indexOf('filename=') !== -1) {
                const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i);
                const extracted = decodeURIComponent(match?.[1] || match?.[2] || '').trim();
                if (extracted) filename = extracted;
            }
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            anchor.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Failed to download invoice:', error);
            toast.error('Failed to download invoice');
        }
    };

    const deleteInvoice = (iId) => {

    }

    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRef?.current) {
            // if (gridData[activeTab]) {
            // var token = "Bearer " + localStorage.RFS;
            jqxCookieCall()

            const source = {
                datatype: 'json',

                root: 'response_data',
                cache: false,
                datafields: [
                    { name: 'category', type: 'string' },
                    { name: 'cost', type: 'string' },
                    { name: 'created_by', type: 'string' },
                    { name: 'created_on', type: 'string' },
                    { name: 'currency', type: 'string' },
                    { name: 'id', type: 'string' },
                    { name: 'no', type: 'string' },
                    { name: 'org_id', type: 'string' },
                    { name: 'activity_status', type: 'string' },
                    { name: 'total_amount', type: 'string' },
                    { name: 'ttl', type: 'string' },
                    { name: 'updated_on', type: 'string' },
                    { name: 'vat', type: 'string' },
                    { name: 'vat_amount', type: 'string' },
                    { name: 'vat_applicable', type: 'string' },
                    { name: 'customer', type: 'string' },
                    { name: 'customer_details', type: 'string' },
                ],
                url: `${process.env.REACT_APP_RFS_URL}shipment/get-invoice-categories?currency=${selectedCurrency}&status=Active`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                // localdata: gridData[activeTab],
                pagesize: 20,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRef.current).jqxGrid('clearselection');
                    window.$(gridRef.current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRef.current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRef.current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    // setTotalRows({ totalUlds: data.activeCount });
                    // setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRef.current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Status',
                    datafield: 'activity_status',
                    width: '10%',
                    filterable: true,
                    filtertype: 'checkedlist',
                    filteritems: [
                        { label: 'Active', value: '1' },
                        { label: 'Inactive', value: '0' },
                    ],
                    cellsrenderer: (rowIndex, dataField, cellValue) => {
                        const isActive = cellValue === '1' || cellValue === 1;
                        const status = isActive ? 'Active' : 'Inactive';
                        const colorClass = isActive ? 'text-success' : 'text-danger';

                        return `<div class="grid_actions"><span class="${colorClass} ">${status}</span></div>`;
                    }
                },
                { text: 'Currency', datafield: 'currency', width: '10%' },
                // { text: 'VAT Applicable', datafield: 'vat_applicable', width: '10%' },
                {
                    text: 'VAT Applicable',
                    datafield: 'vat_applicable',
                    width: '10%',
                    cellsrenderer: (rowIndex, dataField, cellValue) => {
                        const text = cellValue == '0' || cellValue == 0 ? 'Exclude GST' : 'Include GST';
                        return `<div class="grid_actions">${text}</div>`;
                    }
                },
                { text: 'Number', datafield: 'no', width: '5%' },
                {
                    text: 'Customer',
                    datafield: 'customer_details',
                    width: '12%',
                    cellsrenderer: (rowIndex, dataField, cellValue) => {
                        const name = cellValue?.name || 'N/A';
                        const displayName = name.length > 20 ? name.slice(0, 20) + '...' : name;
                        return `<div class="grid_actions" title="${name}">${displayName}</div>`;
                    }
                },
                { text: 'Category', datafield: 'category', width: '10%' },
                { text: 'Cost', datafield: 'cost', width: '8%' },
                { text: 'TTL', datafield: 'ttl', width: '8%' },
                { text: 'VAT %', datafield: 'vat', width: '8%' },
                { text: 'VAT Amount', datafield: 'vat_amount', width: '10%' },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 20,
                pagesizeoptions: ['20', '50', '100', '200'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                // rendered: function () {
                //   const rows = window.$(gridRef.current).jqxGrid('getrows');
                //   (checkUlds).forEach(uldNumber => {
                //     rows.forEach((element, index) => {
                //       if (element.uld_number == uldNumber) {
                //         window.$(gridRef.current).jqxGrid('selectrow', index);
                //       }
                //     });
                //   });
                // }
            };
            window.$(gridRef.current).jqxGrid(gridOptions);
            window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');
            window.$(gridRef.current).on('click', '.row_edit', function () {
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
                const dataToSend = {
                    uld_number: rowData.uld_number,
                    type_code: rowData.type_code,
                    serial_number: rowData.serial_number,
                    owner_code: rowData.owner_code,
                    condition_code: rowData.condition_code,
                    asset_type: rowData.asset_type == 'Y' ? false : true
                };
                // setEditData(dataToSend);
                // setShowEdit(true);
            });
            // window.$(gridRef.current).on('click', '.screen', function () {
            //     const rowDiv = window.$(this).closest('[role="row"]');
            //     const rowIndex = window.$(rowDiv).attr('row-id');
            //     const rowData = window.$(gridRef.current).jqxGrid('getrowdata', rowIndex);
            //     setIsModal(true)
            // });
            window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRef.current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.id;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.id === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRef.current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRef.current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.id;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.id !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            // window.$(gridRef.current).off('cellclick');
            // window.$(gridRef.current).on('cellclick', (event) => {
            //     const args = event.args.row.bounddata;
            //     if (![4, 10].includes(event.args.columnindex)) {
            //         if (gridSelect) {
            //             gridSelect.forEach(item => {
            //                 const selectedRowBoundIndex = item.boundindex;
            //                 window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            //             });
            //         }
            //         // loadDetails(args.uld_number);
            //         setSelectedRowData(args)
            //         setTimeout(() => {
            //             window.$(gridRef.current).jqxGrid('refresh');
            //         }, 30);
            //     }
            // });
            // }
        }
    }, [gridData]);


    const HandleInvoiceDetails = (data) => {
        setSelectedRowData(data);
        const invData = data?.items.map((itm, index) => {
            let amount = itm.amount;
            if (typeof amount === "number") {
                amount = amount.toFixed(2).replace('.', ',');
            } else if (typeof amount === "string" && amount.includes('.')) {
                amount = amount.replace('.', ',');
            }

            return {
                ...itm,
                no: index + 1,
                qty: itm.qty,
                category: itm.category.id || itm.category || itm.category_name,
                amount,
                newCat: itm.category.is_custom == 1 ? true : false,
                ttl: itm.amount * itm.qty,
                vat: itm.vat,
                vatAmount: calculateVatAmount(itm.qty * itm.amount, itm.vat),

            }
        })
        // console.log('invData', invData);

        setInvoiceDetails(invData)
        setRowAdd(false)
    }
    const handleRowAdd = () => {
        setRowAdd(true);
        setSelectedRowData({})
        setInvoiceDetails([])
    }

    const backToGrid = () => {
        setSelectedRowData(null);
        setIsLoadingi(false);
        setIGridData([]);
        if (formData?.id) {
            offDetails();
        }
    }
    // console.log('onSuccess', onSuccess);


    // useEffect(() => {
    //     if (onSuccess) {
    //         setIsUpdate(onSuccess)
    //     }
    // }, [onSuccess]);

    const cancelGrid = () => {
        setDetailsData(allData);
        setFormData(allData?.invoices);
        onSave([])

        setSelectedRowData(null);
        setIsLoadingi(false);
        setIGridData([]);
        offDetails();
        setIsUpdate(false)
        if (formData?.id) {
        }
    }
    const openConf = () => {
        setConfData({
            header: 'Cancel Without saving',
            subHeader: 'Are you sure you want to cancel the changes?',
            modalConf: cancelGrid,
            closeModal: confModalClose,
            primaryBtn: 'Yes',
            secondaryBtn: 'No',
        })
        setModalConf(true)
    }
    const confModalClose = () => { setModalConf(false) }
    const addToGrid = () => {
        const addd = { currency: selectedCurrency, items: invoiceDetails, updated_at: `${new Date().toISOString()}T1`, status: 'New', new: true }
        setFormData(prev => [...prev, addd]);
        setSelectedRowData(null)
        onSave([...formData, addd])
    }

    const handleAction = (act) => {
        if (act === 'D') {
            const rowData = invoiceDetails.length ? invoiceDetails : [{ ...defaultRow }];
            handleSave('D', rowData)
        } else if (act === 'DC') {
            const crAmount = invoiceDetails.map(item => {
                let amount = item.amount?.toString().trim();
                let ttl = item.ttl?.toString().trim();
                let vatAmount = item.vatAmount?.toString().trim();
                let total = item.total?.toString().trim();

                // if (amount && !amount.startsWith('-')) {
                //     amount = `-${amount}`;
                //     ttl = `-${ttl}`;
                //     vatAmount = `-${vatAmount}`;
                //     total = `-${total}`;
                // }

                const toggleSign = (val) => {
                    if (!val) return val;
                    return val.startsWith('-') ? val.slice(1) : `-${val}`;
                };

                amount = toggleSign(amount);
                ttl = toggleSign(ttl);
                vatAmount = toggleSign(vatAmount);
                total = toggleSign(total);

                return { ...item, amount, ttl, vatAmount, total };
            })
            const rowData = crAmount.length ? crAmount : [{ ...defaultRow }];
            console.log('rowData', rowData);

            handleSave('D', rowData)

        }
    }

    const handleInvoiceMove = (st, dt) => {
        console.log('dt', dt);
        console.log('st', st);

        setConfData({
            header: `Invoice ${st === 0 ? 'Activation' : 'Deactivation'}`,
            subHeader: `Are you sure you want to ${st === 0 ? 'Activate' : 'Deactivate'} the Invoice?`,
            modalConf: () => confirmInvoiceMove(st, dt),
            closeModal: confModalClose,
            primaryBtn: `${st === 0 ? 'Active' : 'Deactive'}`,
            secondaryBtn: 'Cancel',
        })
        setModalConf(true)
    }
    const confirmInvoiceMove = (st, dt) => {
        CallApi({
            endPoint: 'invoice/remove',
            payload: { ids: [dt.id], is_deleted: st },
            onSuccess: (data) => {
                // console.log('sendData', data);
                const resCode = data.data.response_code;
                if (resCode === 200) {
                    loadDetails();
                } else {
                    toast.error(data.response_msg);
                }
                // setIsLoading(false)
            },
            onError: (msg) => toast.error(msg)
        });
    }
    // set email manual logic 

    const [linkModal, setLinkModal] = useState(false);
    const [manualSendData, setManualSendData] = useState(null);
    const [manualSendToggle, setManualSendToggle] = useState(null);

    const openManualSendModal = (data) => {
    setManualSendData(data?.id);
    setManualSendToggle(data?.is_send_manually);
    setLinkModal(true);
    };

    const closeManualSend = () => {
        setLinkModal(false);
        setManualSendData(null);
    };

   const submitManualSend = async () => {
        if (manualSendToggle === null) {
            toast.error('Please select Yes or No');
            return;
        }
        try {
            const res = await withRFSToken.post('invoice/check-mail-send', {
                id: manualSendData,
                is_manual: manualSendToggle,
            });
            if (res?.data?.response_code === 200) {
                toast.success('Manual send updated successfully');
                loadDetails();
                closeManualSend();
            } else {
                toast.error(res?.data?.response_msg || 'Something went wrong');
            }
        } catch (error) {
            console.error('Error submitting manual send:', error);
            toast.error('Failed to submit');
        }
    };

    return (
        <>
            {/* {console.log('formData', formData)} */}
            {/* {console.log('rows', rows)}
            {console.log('invoiceDetails', invoiceDetails)} */}
            {/* {console.log('selectedRowData', selectedRowData)} */}
            {modalConf &&
                <ConfModal
                    header={confData.header}
                    subHeader={confData.subHeader}
                    modalConf={confData.modalConf}
                    closeModal={confData.closeModal}
                    primaryBtn={confData.primaryBtn}
                    secondaryBtn={confData.secondaryBtn}
                />
            }
            {!selectedRowData ?
                <div className='trashdonload'>
                    {/* {!isLoadingi && <div ref={gridRefi} className='bookinggrid' ></div>} */}
                    <div className='flbg'>
                        <div className='text-end mb-2 d-flex justify-content-between align-items-center invoice_dv'>
                            <h6 className='mb-0'>
                                <span>Total Amount:</span>
                                {getCurrencySymbol()} {formData?.filter(dt => dt.is_deleted === 0)?.reduce((sum, item) => sum + Number(item.total || 0), 0).toFixed(2)}
                            </h6>
                            <Button onClick={handleRowAdd} className='ms-2' disabled={!allData.master_airwaybill}>Add Invoice</Button>
                        </div>
                        <div className='invoice_table'>
                            <Table responsive >
                                <thead>
                                    <tr>
                                        <th>Invoice number</th>
                                        <th>Customer</th>
                                        <th>Invoice date</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                        <th>Download</th>
                                        <th>Mail Send</th>
                                        <th>Delete</th>
                                    </tr>
                                </thead>
                                {/* {console.log('invoiceDetails', invoiceDetails)} */}
                                {console.log("formDataaaaa",formData)}
                                <tbody>
                                    {formData?.length ? formData?.map((data, index) => (
                                        <tr>
                                            <td style={{ opacity: data.is_deleted == 1 ? '0.4' : '' }} onClick={() => HandleInvoiceDetails(data)}>{data.invoice_id}</td>
                                            <td style={{ opacity: data.is_deleted == 1 ? '0.4' : '' }} onClick={() => HandleInvoiceDetails(data)}>{allData?.customer_name || ''}</td>
                                            <td style={{ opacity: data.is_deleted == 1 ? '0.4' : '' }} onClick={() => HandleInvoiceDetails(data)}>{data?.created_at?.split('T')[0]}</td>
                                            {/* <td>{data?.contact}</td> */}
                                            <td style={{ opacity: data.is_deleted == 1 ? '0.4' : '' }}>{getCurrencySymbol()} {data.total} </td>
                                            <td style={{ opacity: data.is_deleted == 1 ? '0.4' : '' }}><span className='invoice_status'>{data?.status}</span></td>
                                            <td style={{ opacity: data.is_deleted == 1 ? '0.4' : '' }}><img src={Download_pdf} alt='' onClick={() => downloadInvoice('pdf', data.id)} style={{ width: '25px' }} /></td>
                                            {/* <td><img src={Trash} alt='' onClick={() => deleteInvoice(data.id)} style={{ width: '20px' }} /></td> */}
                                            <td>
                                            <td>
                                                {(data.is_send_manually !== 1 && data.send_status === 1) && (
                                                    <img src={greencheck} alt="sent" style={{ width: '16px', height: '16px', marginLeft: '27px' }} />
                                                )}
                                                {(data.is_send_manually === 1 && data.send_status === 1) && (
                                                    <img src={manualgreencheck} alt="sent" style={{ width: '16px', height: '16px', marginLeft: '27px' }} onClick={(e) => { e.stopPropagation(); openManualSendModal(data);} } />
                                                )}
                                                {(data.is_send_manually !== 1 && data.send_status !== 1)&& (
                                                <div
                                                    className="set_fn ms-2"
                                                    onClick={(e) => { e.stopPropagation(); openManualSendModal(data);}}
                                                    style={{ cursor: 'pointer' }}>
                                                    <span className="screen screen_edit">
                                                        <img src={pen} alt="edit" /> Set
                                                    </span>
                                                </div>
                                                )}
                                            </td>
                                            </td>
                                            <td>
                                                <Form.Check
                                                    type="switch"
                                                    id={`switch-${index}`}
                                                    checked={data.is_deleted === 0}
                                                    onChange={(e) => {
                                                        const newStatus = e.target.checked ? 0 : 1;
                                                        handleInvoiceMove(newStatus, data)
                                                        // setFormData(prevFormData => prevFormData.map((dta, idx) => {
                                                        //     if (idx === index) {
                                                        //         return { ...dta, is_deleted: newStatus };
                                                        //     }
                                                        //     return dta;
                                                        // }));
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                    ))
                                        :
                                        <tr><td></td></tr>
                                    }
                                </tbody>
                            </Table>
                        </div>

                    </div>

                </div>
                : <>
                    <div>
                        <Row>
                            <Col lg={12}>
                                <div className='flbg invoice_dv' ref={invoiceRef}>
                                    <div className='invoice_hdr px-3'>

                                        <div className='d-flex align-items-center mb-3'>
                                            {/* <h4><span className='pe-3'></span> </h4> */}
                                            {/* {!rowAdd && */}
                                            <>
                                                {/* <Button onClick={openConf}>Cancel</Button> */}
                                                {onEdit ?
                                                    <Button onClick={openConf}>Cancel</Button>
                                                    : <></>
                                                    // <Button onClick={backToGrid}>Back</Button>
                                                }
                                                {rowAdd && <>{!onEdit && <Button onClick={backToGrid}>Back</Button>}</>}
                                                {isUpdate && rowAdd &&
                                                    <>
                                                        {/* <Button onClick={openConf}>Cancel</Button> */}
                                                        {/* <Select
                                                            options={[
                                                                { label: 'Duplicate', value: 'D' },
                                                                { label: 'Duplicate credit invoice', value: 'DC' },
                                                            ]}
                                                            onChange={(selected) => handleAction(selected.value)}
                                                            placeholder="Actions"
                                                            className='down_selct'
                                                            name="action"
                                                        // value={categoriesList?.find(option => option.value === row.category.id) || null}
                                                        // menuPortalTarget={document.body}
                                                        // menuPosition="fixed"
                                                        // styles={{
                                                        //     menuPortal: base => ({ ...base, zIndex: 9999 })
                                                        // }}
                                                        /> */}
                                                    </>
                                                }
                                                {!rowAdd &&
                                                    <>
                                                        {!onEdit && <Button onClick={backToGrid}>Back</Button>}
                                                        <Select
                                                            options={[
                                                                { label: 'Duplicate', value: 'D' },
                                                                { label: 'Duplicate credit invoice', value: 'DC' },
                                                            ]}
                                                            onChange={(selected) => handleAction(selected.value)}
                                                            placeholder="Actions"
                                                            className='down_selct ms-auto'
                                                            name="action"
                                                        // value={categoriesList?.find(option => option.value === row.category.id) || null}
                                                        // menuPortalTarget={document.body}
                                                        // menuPosition="fixed"
                                                        // styles={{
                                                        //     menuPortal: base => ({ ...base, zIndex: 9999 })
                                                        // }}
                                                        />
                                                    </>
                                                }

                                                {!rowAdd &&
                                                    <div className='button-group invoice_btn_grp ms-2'>
                                                        <Button onClick={() => downloadInvoice('excel', selectedRowData.id)}><span className='pe-2'><img src={xls_file} /></span>Excel</Button>
                                                        <Button><span className='pe-2'><img src={mail} /></span>Email</Button>
                                                        <Button className='invoic_btn_active' onClick={() => downloadInvoice('pdf', selectedRowData.id)}><span className='pe-2'><img src={dwnld} /></span>PDF</Button>
                                                    </div>
                                                }
                                            </>
                                            {/* } */}
                                        </div>
                                        <div className='d-flex align-items-start mb-3 invoice_bdy'>
                                            <div className='invc_add_dv'>
                                                <h2 className='mb-0'>Invoice</h2>
                                            </div>
                                            <div className='invoice_details'>
                                                <img src={detailsData?.organization?.org_Logo} style={{ width: '180px' }} alt='' />
                                                <p className='mb-1'> {detailsData?.organization?.fixed_org_Name}</p>
                                                {/* <p className='mb-1'> Pelikaanweg 201,</p> */}
                                                <p className='mb-1'
                                                    dangerouslySetInnerHTML={{
                                                        __html: detailsData?.organization?.main_Address?.replace(/\r?\n/g, '<br />') || ''
                                                    }}
                                                ></p>
                                                <p className='mb-1'>Phone: {detailsData?.organization?.cell_Phone}</p>
                                                <p className='mb-1'> E-mail: {detailsData?.organization?.email_ID}</p>
                                                {/* <p className='mb-1'> Website: www.customssupport.com</p> */}
                                            </div>

                                        </div>
                                    </div>
                                    <hr />
                                    <div className='invoice_bdy d-flex align-items-start mb-2 px-3'>
                                        <div className='invc_add_dv invoice_details'>
                                            <div>
                                                <h6>Invoice Address:</h6>
                                                <p className='mb-0 addrss'>Billed To: {detailsData?.customer_name}</p>
                                                <p className='addrss'>
                                                    { [
                                                        detailsData?.customer?.street_name,
                                                        detailsData?.customer?.city,
                                                        detailsData?.customer?.postal_code,
                                                        detailsData?.customer?.country
                                                      ]
                                                            .filter(Boolean)
                                                            .join(', ')
                                                    }
                                                    </p>
                                                {/* <p className='mb-0'> Dsv Air & Sea Nederland B.V. (NLASADM)</p> */}
                                            </div>
                                        </div>
                                        <div>
                                            <div className='invoice_details'>
                                                {/* {console.log("selectedRowDataaaaaa",selectedRowData)}
                                                {console.log("detailsDataaaaa",detailsData)} */}
                                                <h6>Invoice Details:</h6>
                                                <p className='mb-0'>Invoice Number : {selectedRowData.invoice_id}</p>
                                                <p className='mb-0'>Date Issued: {selectedRowData?.created_at?.split('T')[0] || formattedDate}</p>
                                               <p className='mb-0'>
                                                    Due Date : {
                                                        selectedRowData?.expiry_date
                                                        ? selectedRowData.expiry_date
                                                        : new Date(
                                                            new Date(selectedRowData?.created_at || Date.now())
                                                                .setDate(
                                                                new Date(selectedRowData?.created_at || Date.now()).getDate() +
                                                                Number(allData?.customer?.expire_days || 0)
                                                                )
                                                            ).toLocaleDateString('en-US', {
                                                            year: 'numeric',
                                                            month: 'long',
                                                            day: 'numeric'
                                                            })
                                                    }
                                                    </p>
                                                {/* <p className='mb-0'>Due Date :  25-10-2025</p> */}
                                                <p className='mb-0'>VAT nr:  {detailsData?.customer?.vat_nr} </p>
                                                
                                            </div>
                                        </div>
                                        {/* <div>
                                    <div>
                                        <h6>Billed To:</h6>
                                        <h6>Brightstone Airline</h6>
                                        <p className='addrss'>789 Enterprise Aveneue, Floor 2, Metropolis, Country</p>
                                    </div>
                                    <div className='mt-4'>
                                        <h6>Date Issued:</h6>
                                        <p>January 31,2025</p>
                                    </div>
                                </div> */}
                                    </div>
                                    <hr />
                                    <div className='invoice_table px-3 text-center'>
                                        <h5 className='text-start d-flex justify-content-between'>Invoice Details</h5>

                                        <Table responsive borderless>
                                            <thead>
                                                <tr>
                                                    <th>NO</th>
                                                    <th>Qty</th>
                                                    <th>Category</th>
                                                    <th>Costs</th>
                                                    <th>TTL</th>
                                                    <th>VAT</th>
                                                    {/* <th>VAT Amount</th> */}
                                                </tr>
                                            </thead>
                                            {console.log('invoiceDetails', invoiceDetails)}
                                            <tbody>
                                                {invoiceDetails && invoiceDetails.map((data, index) => (
                                                    <tr>
                                                        <td>{data.no}</td>
                                                        <td>{data.qty}</td>
                                                        {/* <td>{categoriesList?.find(opt => opt.value == data.category).label}</td> */}
                                                        <td>{data.category_name ? data.category_name : categoriesList?.find(opt => opt.value == data.category)?.label}</td>
                                                        <td>{data.amount}</td>
                                                        <td>{data.ttl}</td>
                                                        <td>{data.vat}%</td>
                                                        {/* <td>{data.vatAmount}</td> */}
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </div>
                                    <hr />
                                    <Button to='#' onClick={handleShow} className='inv_ser_category'>Search Category</Button>
                                    <div className='invoice_subtotal d-flex justify-content-end invoice_bdy'>
                                        <div>
                                            <h6>Total Payable:</h6>
                                            <h6><span>Subtotal:</span><span>{getCurrencySymbol()} {invoiceSubtotal().toFixed(2)}</span></h6>
                                            <h6><span>VAT:</span><span>{getCurrencySymbol()} {invoiceVatTotal().toFixed(2)}</span></h6>
                                            <h5><span>Total:</span><span>{getCurrencySymbol()} {invoiceTotal().toFixed(2)}</span></h5>
                                        </div>
                                    </div>
                                    {/* {rowAdd &&
                                        <div>
                                            <Button onClick={backToGrid}>Cancel</Button> <Button onClick={addToGrid}>Save</Button>
                                        </div>
                                    } */}
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <Modal show={categoryModal} onHide={handleClose} className='addfrom add_category_modal' centered size='xl'>
                        <Modal.Header closeButton>
                            <Modal.Title>Search Category</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {modalFor == 'cl' &&
                                <>
                                    <button className='backbtn' onClick={handleCloseGrid}> <FontAwesomeIcon icon={faArrowLeft} /> Back</button>
                                    <div className='trashdonload add_category_modal_bdy_content'>
                                        {!isLoading && <div ref={gridRef} className='bookinggrid' ></div>}
                                    </div>
                                </>
                            }
                            {modalFor == 'ac' &&
                                <>
                                    <div className='d-flex align-items-center justify-content-end category_btn_grp'>
                                        <span>Amount in </span>
                                        <Form.Select
                                            size="sm"
                                            className="euro_amount_select"
                                            value={selectedCurrency}
                                            onChange={handleCurrencyChange}
                                        >
                                            {currencyOptions.map(opt => (
                                                <option key={opt.value} value={opt.value}>{opt.label}</option>
                                            ))}
                                        </Form.Select>

                                        <Button variant="outline-secondary" className={vatType === 'include' ? 'active' : ''} onClick={() => { setModalFor('cl'); setIsLoading(false); setGridData({ Active: {} }); }}>
                                            Category List
                                        </Button>
                                    </div>
                                    <hr />
                                    <div className='search_category_modal_table text-center'>
                                        <Table borderless responsive>
                                            <thead>
                                                <tr>
                                                    <th>NO</th>
                                                    <th>Quantity</th>
                                                    <th>Category</th>
                                                    <th>Custom</th>
                                                    <th>Amount</th>
                                                    <th>Total</th>
                                                    <th>VAT Rate</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {rows.map((row, idx) => (
                                                    <tr key={idx}>
                                                        {/* {console.log('row', row)}
                                                        {console.log('categoriesList', categoriesList)} */}
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                className='form-control'
                                                                value={row.no}
                                                                onChange={e => handleRowChange(idx, 'no', e.target.value)}
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                className='form-control'
                                                                value={row.qty || ''}
                                                                onChange={e => handleRowChange(idx, 'qty', e.target.value)}
                                                            />
                                                        </td>
                                                        <td className='position-relative'>
                                                            {row.newCat ?
                                                                <Form.Control
                                                                    type="text"
                                                                    className='form-control'
                                                                    value={row.category_name || ''}
                                                                    onChange={e => handleRowChange(idx, 'category_name', e.target.value)}
                                                                />
                                                                :
                                                                <Select
                                                                    options={categoriesList}
                                                                    onChange={(selected) => { handleRowChange(idx, 'category', selected); }}
                                                                    placeholder="category"
                                                                    className='down_selct'
                                                                    name="category"
                                                                    value={categoriesList?.find(option => option.value === row.category) || null}
                                                                    menuPortalTarget={document.body}
                                                                    menuPosition="fixed"
                                                                    styles={{
                                                                        menuPortal: base => ({ ...base, zIndex: 9999 })
                                                                    }}
                                                                />
                                                            }

                                                        </td>
                                                        <td><Link className="new_category" to='#' onClick={() => handleToggleCat(idx)}>{row.newCat ? 'Existing' : '+ Add'}</Link></td>
                                                        <td>
                                                            <Form.Control
                                                                type="text"
                                                                className='form-control'
                                                                value={row.amount || ''}
                                                                onChange={e => {
                                                                    let value = e.target.value;

                                                                    // Allow digits, comma, and one leading minus sign
                                                                    // value = value.replace(/(?!^-)[^0-9,]/g, ""); // remove invalid chars except leading '-'
                                                                    value = value.replace(/[^0-9,-]/g, ""); // keep digits, comma, minus
                                                                    value = value.replace(/(?!^)-/g, ""); // remove minus signs that are not at start

                                                                    // Allow only one comma
                                                                    const parts = value.split(",");
                                                                    if (parts.length > 2) {
                                                                        value = parts[0] + "," + parts[1];
                                                                    }

                                                                    // Limit to 2 decimal digits
                                                                    if (parts.length === 2) {
                                                                        value = parts[0] + "," + parts[1].slice(0, 2);
                                                                    }

                                                                    // Prevent multiple '-' or misplaced '-'
                                                                    if (value.split("-").length > 2) {
                                                                        value = value.replace(/-+/, "-"); // keep only one '-'
                                                                    }
                                                                    if (value.indexOf("-") > 0) {
                                                                        value = "-" + value.replace(/-/g, ""); // ensure '-' only at start
                                                                    }

                                                                    handleRowChange(idx, "amount", value);
                                                                }}
                                                            />

                                                        </td>
                                                        <td>
                                                            <Form.Control
                                                                type="number"
                                                                className='form-control'
                                                                value={row.ttl || ''}
                                                                onChange={e => handleRowChange(idx, 'ttl', e.target.value)}
                                                                disabled
                                                            />
                                                        </td>
                                                        <td>
                                                            <Form.Select
                                                                size="sm"
                                                                className="vat_select"
                                                                value={row.vat}
                                                                onChange={e => handleRowChange(idx, 'vat', e.target.value)}
                                                            >
                                                                {vatRates.map(opt => (
                                                                    <option key={opt.value} value={opt.value}>{opt.label}</option>
                                                                ))}
                                                            </Form.Select>
                                                        </td>
                                                        {/* <td>{row.vatAmount}</td> */}
                                                        <td>
                                                            {rows.length > 1 && (
                                                                <img src={dlt} alt='dlt' style={{ cursor: 'pointer' }} onClick={() => handleDeleteRow(idx)} />
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        <div className='dimension_add text-end'>
                                            <button type="button" className="btn btn-primary" onClick={handleAddRow}>+ Add Row</button>
                                        </div>
                                    </div>
                                    <div className='subtotal_dv'>
                                        <p className='mb-2'><span className='me-5'>Subtotal </span><span>{getCurrencySymbol()} {getSubtotal().toFixed(2)}</span></p>

                                        {vatRows && vatRows.map((vat, index) => (
                                            <p className='mb-2'><span className='me-5'>{vat.vat}% btw </span><span>{vat.vatAmount}</span></p>
                                        ))}

                                        <p className='mb-2'><span className='me-5'>VAT Total </span><span>{getCurrencySymbol()} {getVatTotal().toFixed(2)}</span></p>
                                        <p className='mb-2'><span className='me-5'>Total - </span><span className='fw-bold'>{getCurrencySymbol()} {getGrandTotal().toFixed(2)}</span></p>
                                    </div>
                                </>
                            }
                        </Modal.Body>
                        <Modal.Footer className='justify-content-center'>
                            <div className="d-flex w-50 mx-auto are_bottom justify-content-center">
                                {modalFor == 'cl' ?
                                    <>
                                        <Button variant="secondary" onClick={handleCloseGrid}>Cancel</Button>
                                        <Button type="button" className="btn btn-primary" onClick={handleAddtoRow}>Add</Button>
                                    </>
                                    :
                                    <>
                                        <Button variant="secondary" onClick={handleClose}>Cancel</Button>
                                        <Button type="button" className="btn btn-primary" onClick={() => handleSave('')}>Save</Button>
                                    </>
                                }
                            </div>
                        </Modal.Footer>
                    </Modal>
                    
                </>
            }
           <Modal show={linkModal} onHide={closeManualSend} className="addfrom change_type" centered>
                <Modal.Header closeButton></Modal.Header>
                <Modal.Body>
                    <h3>Manual Report Send</h3>
                    <Form.Label>Manual Send Email :  &nbsp;
                        {new Date().toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                        })}
                        {' '}
                        {new Date().toLocaleTimeString('en-US', {
                            hour: '2-digit',
                            minute: '2-digit',
                        })}
                    </Form.Label>
                    <Form.Label>Send Manually</Form.Label>
                    <span className='d-flex'>
                        <Form.Check
                            type="radio"
                            label="Yes"
                            name="manual_send"
                            value="true"
                            id="manual_send-1"
                            checked={manualSendToggle === 1}
                            onChange={() => setManualSendToggle(1)}
                        />
                        <Form.Check
                            type="radio"
                            label="No"
                            name="manual_send"
                            value="false"
                            id="manual_send-2"
                            checked={manualSendToggle === 0}
                            onChange={() => setManualSendToggle(0)}
                        />
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <div className="d-flex w-50 mx-auto are_bottom">
                        <Button variant="secondary" onClick={closeManualSend}>Cancel</Button>
                        <Button variant="primary" onClick={submitManualSend}>Submit</Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default Invoice